import { Apps } from '@/dtos'
import type { Offer } from 'BrokerTsLib/src/dtos'
import type { Context } from 'react'
import { useContext } from 'react'
import { useApp } from '../hooks/useApp'
import { offersPropertyContext } from './OffersPropertyProvider'
import type { IOffersContext } from './OffersProvider'
import { offersTravelContext } from './OffersTravelProvider'
import { offersVehicleContext } from './OffersVehicleProvider'


export const getOffersContext = (app: Apps) => {
  switch (app) {
    case Apps.leasing:
    case Apps.leasingSimplifiedWizard:
    case Apps.extra:
    case Apps.fleet:
    case Apps.vehicle:
    case Apps.publicPoleas:
      return offersVehicleContext
    case Apps.travel:
      return offersTravelContext
    case Apps.property:
      return offersPropertyContext
    default: throw new Error(`Unknown app: ${app}`)
  }
}

export const useOffersContext = () => {
  const { app } = useApp()
  const ctx = getOffersContext(app!)

  return useContext(ctx as unknown as Context<IOffersContext<Offer>>)
}
